module.exports = __webpack_public_path__ + "c268b8871b9e454b30f623ed88b1b894.png";